export default {
  "首页": "Главная",
  "订单": "Заказы",
  "新闻": "Новости",
  "个人中心": "Личный кабинет",
  "模拟账户": "Демо-аккаунт",
  "可用资产": "Доступные активы",
  "入金": "Пополнение",
  "出金": "Вывод",
  "账单详情": "Детали счета",
  "重置模拟账户": "Сбросить демо-аккаунт",
  "钱包": "Кошелек",
  "实名认证": "Проверка личности",
  "邀请好友": "Пригласить друзей",
  "修改密码": "Изменить пароль",
  "投诉邮箱": "Почта для жалоб",
  "其它": "Другое",
  "公告": "Объявления",
  "语言": "Язык",
  "是否退出登录": "Вы хотите выйти?",
  "复制": "Копировать",
  "复制成功": "Успешно скопировано",
  "发送验证码成功": "Код подтверждения успешно отправлен",
  "请输入密码": "Введите пароль",
  "请再次输入密码": "Введите пароль еще раз",
  "复制邀请链接": "Копировать ссылку для приглашения",
  "上传身份": "Загрузите фото паспорта/документа с обеих сторон",
  "正面": "Лицевая сторона",
  "上传正面": "Загрузите лицевую сторону паспорта/документа",
  "反面": "Оборотная сторона",
  "上传反面": "Загрузите оборотную сторону паспорта/документа",
  "完善信息": "Заполните личные данные",
  "输入姓名": "Введите ваше имя",
  "身份证号": "Номер паспорта/документа",
  "输入身份证号": "Введите номер паспорта/документа",
  "收款货币": "Валюта получения",
  "银行名称": "Название банка",
  "收款人账户": "Счет получателя",
  "货币": "Валюта",
  "分店名称": "Название филиала",
  "绑定银行卡": "Привязать банковскую карту",
  "银行地址": "Адрес банка",
  "账号名称（假名）": "Название аккаунта (псевдоним)",
  "绑定数字货币地址": "Привязать адрес криптовалюты",
  "余额": "Баланс",
  "联系客服": "Связаться с поддержкой",
  "行情": "Рынок",
  "其他": "Другое",
  "设置": "Настройки",
  "收款人": "Получатель",
  "添加": "Добавить",
  "确认": "Подтвердить",
  "取消": "Отменить",
  "钱包地址": "Адрес кошелька",
  "请输入": "Введите",
  "退出登录": "Выйти",
  "充值数量": "Сумма пополнения",
  "提交": "Отправить",
  "银行卡": "Банковская карта",
  "选择网络": "Выбрать сеть",
  "数字货币": "Криптовалюта",
  "上传验证": "Загрузка подтверждения",
  "提币地址": "Адрес для вывода",
  "数量(USD)": "Количество (USD)",
  "备注": "Примечание",
  "手续费": "Комиссия",
  "预计到账数量": "Ожидаемая сумма поступления",
  "暂无数据": "Нет данных",
  "入金记录": "Запись о пополнении",
  "提币记录": "Запись о выводе",
  "验证码": "Код подтверждения",
  "邀请码": "Пригласительный код",
  "提示": "Подсказка",
  "请输入验证码": "Введите код подтверждения",
  "姓名": "Имя",
  "邮箱登录": "Вход через email",
  "邮箱": "Email",
  "密码": "Пароль",
  "新用户": "Новый пользователь",
  "立即加入": "Присоединиться сейчас",
  "忘记密码": "Забыли пароль?",
  "登录": "Войти",
  "无需开户,立即创建模拟账号进行交易!": "Не требуется открытие счета, создайте демо-аккаунт и начинайте торговать!",
  "电话": "Телефон",
  "再次输入密码": "Введите пароль еще раз",
  "职业": "Профессия",
  "年收入": "Годовой доход",
  "注册": "Регистрация",
  "邮箱注册": "Регистрация через email",
  "发送": "Отправить",
  "重置密码": "Сбросить пароль",
  "是否重置": "Вы уверены, что хотите сбросить?",
  "已重置": "Сброшено",
  "名称": "Название",
  "注册成功": "Регистрация успешна",
  "加载中": "Загрузка",
  "您还未登录，请先登录": "Вы еще не вошли, пожалуйста, войдите",
  "退出成功": "Выход выполнен успешно",
  "市价": "Рыночная цена",
  "挂单": "Ожидающий ордер",
  "倍数": "Множитель",
  "止盈": "Тейк-профит",
  "止损": "Стоп-лосс",
  "买入数量": "Количество для покупки",
  "每手": "За контракт",
  "预估手续费": "Ожидаемая комиссия",
  "预估保证金": "Ожидаемая маржа",
  "买入": "Купить",
  "卖出": "Продать",
  "您的订单已确认": "Ваш заказ подтвержден",
  "订单页面": "Страница заказов",
  "盈亏": "Прибыль/убыток",
  "当前保证金": "Текущая маржа",
  "订单详情": "Детали заказа",
  "保证金": "Маржа",
  "平仓": "Закрыть позицию",
  "修改": "Изменить",
  "手数": "Количество контрактов",
  "暂无数据": "Нет данных",
  "历史": "История",
  "价格": "Цена",
  "请输入价格": "Введите цену",
  "手": "Контракт",
  "搜索结果": "Результаты поиска",
  "搜索产品": "Поиск продукта",
  "持仓": "Позиции",
  "语言": "Язык",
  "审核中": "На проверке",
  "请上传证件照正/反面": "Пожалуйста, загрузите фото лицевой/обратной стороны документа",
  "上传成功": "Загрузка успешна",
  "上传失败": "Загрузка не удалась",
  "提交成功": "Отправка успешна",
  "删除": "Удалить",
  "删除成功": "Удалено успешно",
  "提币": "Вывод",
  "缺少参数或传值错误": "Отсутствуют параметры или ошибка значения",
  "操作成功": "Операция успешна",
  "充值金额": "Сумма пополнения",
  "类型": "Тип",
  "状态": "Статус",
  "时间": "Время",
  "单位": "Единица",
  "最高价": "Максимальная цена",
  "最低价": "Минимальная цена",
  "开盘价": "Цена открытия",
  "请注册或登录真实账号": "Пожалуйста, зарегистрируйтесь или войдите в реальный аккаунт",
  "没有更多了": "Нет больше данных",
  "提现金额": "Сумма вывода",
  "审核通过": "Проверка пройдена",
  "审核不通过": "Проверка не пройдена",
  "重新提交": "Переслать",
  "止盈价": "Цена тейк-профит",
  "止损价": "Цена стоп-лосс",
  "总盈亏": "Общий прибыль/убыток",
  "撤单": "Отменить заказ",
  "请先进行实名认证": "Пожалуйста, пройдите проверку личности",
  "产品列表": "Список продуктов",
  "下单": "Разместить заказ",
  "可用资金": "Доступные средства",
  "欢迎登录": "Добро пожаловать",
  "可用": "Доступно",
  "冻结": "Заморожено",
  "财务记录": "Финансовые записи",
  "交易对": "Торговая пара",
  "开仓时间": "Время открытия позиции",
  "收益": "Доход",
  "操作": "Действие",
  "下单价": "Цена заказа",
  "当前价": "Текущая цена",
  "订单号": "Номер заказа",
  "请选择": "Выберите",
  "卖出(做空)止损价不能低于开仓价": "Цена стоп-лосса при продаже (короткая позиция) не может быть ниже цены открытия",
  "卖出(做多)止盈价不能高于开仓价": "Цена тейк-профита при продаже (длинная позиция) не может быть выше цены открытия",
  "买入(做多)止损价不能高于开仓价": "Цена стоп-лосса при покупке (длинная позиция) не может быть выше цены открытия",
  "买入(做多)止盈价不能低于开仓价": "Цена тейк-профита при покупке (длинная позиция) не может быть ниже цены открытия",
  "买入(做多)止盈价不能低于开仓价和现价": "Цена тейк-профита при покупке (длинная позиция) не может быть ниже цены открытия и текущей цены",
  "买入(做多)止损价不能高于开仓价和现价": "Цена стоп-лосса при покупке (длинная позиция) не может быть выше цены открытия и текущей цены",
  "卖出(做空)止损价不能低于开仓价和现价": "Цена стоп-лосса при продаже (короткая позиция) не может быть ниже цены открытия и текущей цены",
  "卖出(做多)止盈价不能高于开仓价和现价": "Цена тейк-профита при продаже (длинная позиция) не может быть выше цены открытия и текущей цены",

  "提现手续费": "Сборы за снятие наличных средств",
  "提现退回": "Возврат наличных средств",
  "系统加款": "Системные надбавки",
  "系统减款": "Системные сокращения",

  "交易周期": "Цикл сделки",
  "秒": "Секунда",
  "交易额": "Сумма сделки",
  "买涨": "Купить с надеждой на рост цены",
  "买跌": "Купить с надеждой на понижение цены",
  "秒数": "Количество секунд",
  "交易类型": "Тип сделки",
  "看涨": "Надеяться на рост цены",
  "看跌": "Надеяться на понижение цены",
  "剩余时间": "Оставшееся время",
  "买入价": "Купленная цена",
  "结算价": "Стоимость расчета",
  "交易额": "Сумма сделки",
  "下单时间": "Время оформления заказа",
  "结算时间": "Время расчета",
  "该币种暂无交易": "Валюта не торгуется",

  "总资产": "Общий объем активов",
  "币种": "Валюта",
  "资产折合": "Пересчет активов",
  "冻结金额": "Зафrozenная сумма",
  "可用金额": "Доступная сумма",
  "公司资产": "Активы компании",
  "请输入旧密码": "Пожалуйста, введите старый пароль",
  "请输入新密码": "Пожалуйста, введите новый пароль",
  "请再次输入新密码": "Пожалуйста, введите новый пароль еще раз",
  "白皮书": "Белая книга",
  "注册证书": "Свидетельство о регистрации",
  "MSB": "MSB",
  "上述信息最终解释权归官方所有": "Право на конечное толкование вышеперечисленной информации принадлежит официальной стороне.",
  "上一页": "Предыдущая страница",
  "下一页": "Следующая страница",
  "关闭": "Закрыть",
  "闪电兑换": "Мгновенное обмен",
  "全部": "Все",
  "可用余额": "Доступный остаток",
  "到": "До",
  "请输入数量": "Пожалуйста, введите количество",
  "币种选择": "Выбор валюты",
  "从": "Из",
  "兑换": "Обменять",
  "兑换成功！": "Обмен удался!",
  "支付": "Оплатить",
  "全部兑换成功": "Все обмены прошли успешно",
  "获取": "Получить",
  "数量": "количество",
  "拒绝原因": "Причины отказа",
  "交易密码": "Пароль для транзакции",
  "设置交易密码": "Установить пароль для транзакции",
  "重置交易密码": "Сбросить пароль для транзакции",
  "确定": "Подтвердить",
  "是否购买？": "Купить?",
  "外汇": "Форекс",
  "期权": "Опционы",
  "(用户中心)": "(Личный кабинет)",
  "您的交易正在处理中,请耐心等待交易完成再进行其他操作!": "Ваша транзакция обрабатывается. Пожалуйста, терпеливо дождитесь завершения транзакции, прежде чем выполнять другие операции!",
  "继续下单": "Продолжить заказ",
  "交易方向": "Направление торговли",
  "实现盈利": "Получить прибыль",
  "最新价格": "Последняя цена",
  "结算完成": "Расчет завершен",
  "下单余额不足": "Недостаточно средств для оформления заказа",
  "输入交易额度": "Введите сумму транзакции",
  "选择交易周期": "Выберите срок сделки",
  "审核拒绝": "Проверка отклонена",
  "请输入正确的数量!": "Пожалуйста, введите правильное количество!",
  "上传身份": "Загрузите удостоверение личности",
  "上传正面": "Загрузите лицевую сторону",
  "上传反面": "Загрузите оборотную сторону",
  "完善信息": "Заполните информацию",
  "输入姓名": "Введите имя",
  "输入身份证号": "Введите номер удостоверения личности",
  "身份证号": "Номер удостоверения личности",
  "请上传证件照正/反面": "Пожалуйста, загрузите фото удостоверения личности с лицевой и оборотной стороной",
  "最小提现金额10USDT": "Минимальная сумма вывода составляет 10 USDT",
  "证件号码": "Номер документа",
  "输入证件号码": "Введите номер документа",
  "请上传身份证、驾驶证或护照其中一种进行身份认证！": "Пожалуйста, загрузите ваше удостоверение личности, водительское удостоверение или паспорт для подтверждения личности!"


}
